__turbopack_context__.v({
  "approval-hand-wave": "BgazwG_approval-hand-wave",
  "approvalHand": "BgazwG_approvalHand",
});
